import { createAction } from '@ngrx/store';

export const OverlayOnAction = createAction('[Overlay] On');

export const OverlayOffAction = createAction('[Overlay] Off');
